<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Shipping Line Booking Order</b-navbar-brand>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="
            BookingShippingLine.allModuleId
              ? BookingShippingLine.allModuleId
              : ''
          "
          :jobSeriesBanner="
            BookingShippingLine.assignmentNumber
              ? BookingShippingLine.assignmentNumber
              : ''
          "
          :bannerClientName="
            BookingShippingLine.clientName ? BookingShippingLine.clientName : ''
          "
          :trackingId="trackingId != '' ? trackingId : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <md-layout gutter>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Assignment No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="assignmentNumber"
                    id="assignmentNumber"
                    v-model="BookingShippingLine.assignmentNumber"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Enter Booking Number *</label>
                  <!-- {{BookingShippingLine}} -->
                  <!-- {{ffBookingDetail}} -->
                  <model-list-select
                    :isDisabled="
                    BookingShippingLine.is_booking_updated=='1'?false:
                      $sessionsStorage.get('designation') != 'Admin' &&
                      BookingShippingLine.conFclBookingId
                        ? true
                        : false
                    "
                    v-if="BookingShippingLine.is_mainbookingFlow == 2"
                    option-value="booking_no"
                    option-text="booking_no"
                    :list="ConsoleBookingList"
                    placeholder="Select Booking Number"
                    v-model="BookingShippingLine.bookingNumber"
                    @searchchange="SelectConsoleBooking"
                  ></model-list-select>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-else
                    name="bookingNumber"
                    id="bookingNumber"
                    v-model="BookingShippingLine.bookingNumber"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!BookingShippingLine.bookingNumber">{{
                  errorBooking.bookingNumber
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Booking Release Date *</label>
                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="bookingDate"
                  name="bookingDate"
                  v-model="BookingShippingLine.bookingDate"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.bookingDate">
                  {{errorBooking.bookingDate}}
                </span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Booking Validity Date *</label>
                <date-picker
                  :disabled="
                    BookingShippingLine.is_mainbookingFlow == 2 ? true : false
                  "
                  :format="selectDateFormat"
                  lang="en"
                  id="validityBookingDate"
                  name="validityBookingDate"
                  v-model="BookingShippingLine.validityBookingDate"
                ></date-picker>
                <span
                  class="error"
                  v-if="!BookingShippingLine.validityBookingDate"
                  >{{ errorBooking.validityBookingDate }}</span
                >
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>SI Cutoff Date *</label>
                <!-- :disabled="BookingShippingLine.is_mainbookingFlow==2?true:false" -->
                <date-picker
                
                  lang="en"
                  name="SICutOff"
                  id="SICutOff"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.SICutOff"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.SICutOff">{{
                  errorBooking.SICutOff
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label>Gate/Forwarding Open Date </label>

                <date-picker
                  v-model="BookingShippingLine.gateOpenDate"
                  lang="en"
                  name="gateOpenDate"
                  id="gateOpenDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                ></date-picker>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Gate/Forwarding Close Date </label>

                <date-picker
                  v-model="BookingShippingLine.gateCloseDate"
                  lang="en"
                  name="gateCloseDate"
                  id="gateCloseDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Port Cut Off Date </label>

                <date-picker
                  v-model="BookingShippingLine.portCutDate"
                  lang="en"
                  name="portCutDate"
                  id="portCutDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                ></date-picker>
              </md-layout>

              <!-- <md-layout md-flex="5"></md-layout> -->
              <!-- <md-layout md-flex="20">
                <label>ENS Cut Off Date </label>

                <date-picker
                  v-model="BookingShippingLine.ENSCutDate"
                  lang="en"
                  name="ENSCutDate"
                  id="ENSCutDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                ></date-picker>
              </md-layout> -->

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Vessel Sail Date *</label>
                <date-picker
                  lang="en"
                  name="vessel_sale_start_date"
                  id="vessel_sale_start_date"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.vessel_sale_start_date"
                  @input="ChangeDate(BookingShippingLine.vessel_sale_start_date, BookingShippingLine.SICutOff)"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.vessel_sale_start_date">{{
                  errorBooking.vessel_sale_start_date
                }}</span>
              </md-layout> 
            </md-layout>

            <md-layout gutter class="labelMargtop">

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Handover CutOff Date *</label>
                <date-picker
                  lang="en"
                  name="handover_cutoff_date"
                  id="handover_cutoff_date"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.handover_cutoff_date"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.handover_cutoff_date">{{
                  errorBooking.handover_cutoff_date
                }}</span>
              </md-layout> 
              
              <md-layout md-flex="10"></md-layout>
              <md-layout md-flex="15">
                <label>VGM CutOff Date *</label>
                <date-picker
                  lang="en"
                  name="vgmCutOffDate"
                  id="vgmCutOffDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.vgmCutOffDate"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.vgmCutOffDate">{{
                  errorBooking.vgmCutOffDate
                }}</span>
              </md-layout>

              <md-layout md-flex="10"></md-layout>
              <md-layout md-flex="15">
                <label>TR CutOff Date * </label>
                <date-picker
                  lang="en"
                  name="documentCutOffDate"
                  id="documentCutOffDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.documentCutOffDate"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.documentCutOffDate">{{
                  errorBooking.documentCutOffDate
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Enter Vessel Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="vesselName"
                    id="vesselName"
                    v-model="BookingShippingLine.vesselName"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Voyage No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="voyageNo"
                    id="voyageNo"
                    v-model="BookingShippingLine.voyageNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Tentative Vessel ETA</label>
                <date-picker
                  lang="en"
                  name="vesselEta"
                  id="vesselEta"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.vesselEta"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Tentative Vessel ETD</label>
                <date-picker
                  lang="en"
                  name="vesselEtd"
                  id="vesselEtd"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.vesselEtd"
                ></date-picker>
              </md-layout>
            </md-layout>



            <!-- <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label for="bookingShipment">Booking Transhipment</label>
                <model-list-select
                  option-value="bookingShipmentVal"
                  option-text="bookingShipmentText"
                  :list="bookingShipmentList"
                  placeholder="Select Booking Transhipment"
                  v-model="BookingShippingLine.bookingShipment"
                  :isDisabled="tentativeDetailArray.length == 0 ? false : true"
                ></model-list-select>

                <span
                  class="error"
                  v-if="!BookingShippingLine.bookingShipment"
                  >{{ errorBooking.bookingShipment }}</span
                >
              </md-layout>
            </md-layout> -->

            <!-- <div
              v-if="BookingShippingLine.bookingShipment == 'yes'"
              id="TranshipmentDetail"
            >
              <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>
                <h4>
                  <u>
                    Transhipment Details
                    <span
                      class="error"
                      v-if="tentativeDetailArray.length == 0"
                      >{{ bookingLengthError }}</span
                    >
                  </u>
                </h4>
                <md-layout md-flex="30"></md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label for="containerTypeId">Transhipment Port Name</label>

                  <model-list-select
                    @input="getLocationList($event, 'All', 'portMasterList')"
                    @searchchange="
                      getLocationList($event, 'All', 'portMasterList')
                    "
                    option-value="pickupId"
                    option-text="pickupLocation"
                    :list="portMasterList"
                    placeholder="Select Port Name"
                    v-model="TranshipmentDetail.tentativePortId"
                  ></model-list-select>
                  <span
                    class="error"
                    v-if="!TranshipmentDetail.tentativePortId"
                    >{{ errorList.tentativePortId }}</span
                  >
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>ETA DATE</label>
                  <date-picker
                    :format="selectDateFormat"
                    v-model="TranshipmentDetail.etaDate"
                    lang="en"
                    id="etaDate"
                    name="etaDate"
                  ></date-picker>

                  <span class="error" v-if="!TranshipmentDetail.etaDate">{{
                    errorList.etaDate
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>ETD DATE</label>
                  <date-picker
                    :format="selectDateFormat"
                    v-model="TranshipmentDetail.etdDate"
                    lang="en"
                    id="etdDate"
                    name="etdDate"
                  ></date-picker>
                  <span class="error" v-if="!TranshipmentDetail.etdDate">{{
                    errorList.etdDate
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20" style="margin-top: 11px">
                  <b-button
                    variant="outline-info"
                    style="margin-top: 40px"
                    @click="addTentativeDetail"
                    id="addButtonLoader"
                    >{{
                      editIndex == "" &&
                      (editIndex != "0" || editIndex != 0) &&
                      TranshipmentDetail.ffBookingTranshipmentId == ""
                        ? "Add"
                        : "Edit"
                    }}
                    Transhipment</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loader"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>

              <hr
                class="hr-border"
                v-if="tentativeDetailArrayList.length > 0"
              />
              <div class="box" v-if="tentativeDetailArrayList.length > 0">
                <div class="box-header">
                  <h3 class="box-title">
                    <u>Transhipment Details</u>
                  </h3>
                </div>

                <div class="box-body">
                  <table id="ffBookingTentative" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Transhipment Port Name</th>
                        <th>Arrival Time</th>
                        <th>Departure Time</th>

                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in tentativeDetailArrayList"
                        :key="index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.tentativePortName }}</td>
                        <td>{{ item.etaDate | moment }}</td>
                        <td>{{ item.etdDate | moment }}</td>

                        <td>
                          <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="
                              viewEdit(item.conffBookingTranshipmentId, index)
                            "
                          >
                            <md-icon>edit</md-icon>
                          </md-button>
                        </td>
                        <td>
                          <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="
                              DeleteList(item.conffBookingTranshipmentId, index)
                            "
                          >
                            <md-icon>delete_sweep</md-icon>
                          </md-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> -->
            
            <hr class="hr-s" />
            <md-layout md-gutter>
              <md-layout md-flex="45"></md-layout>
              <md-layout md-flex="30">
                <b-button
                  variant="primary"
                  @click="addBookingDetail"
                  id="addButtonLoader1"
                  >Save & Proceed to Execution</b-button
                >

                <md-spinner
                  md-indeterminate
                  id="loader1"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>

            <span class="error pull-right" v-if="Created">
              <b> {{ Created }}</b>
            </span> <br>       

            <span class="error pull-right" v-if="Updated">
              <b> {{ Updated }}</b>
            </span>    
            
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopBooking"
      @close="proceedToExec"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import BannerComponent from "../allModuleForm/trackingBannerComponent.vue";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";

export default {
  beforeMount() {
    //  this.getTrackingLink();
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editffFclConsoExportId") != undefined &&
      this.$sessionsStorage.get("editffFclConsoExportId") != ""
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/ffExportCon/fclConsoBookingOrder"
      );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      selectDateFormat,
      trackingId: "",
      isLoading: false,
      ConsoleBookingList: [],
      // bookingShipmentName: [
      //   {
      //     bookingShipmentVal: "yes",
      //     bookingShipmentText: "Yes",
      //   },
      //   {
      //     bookingShipmentVal: "no",
      //     bookingShipmentText: "No",
      //   },
      // ],
      value12: "",
      BookingShippingLine: {
        is_booking_updated:0,
        allModuleId: "",
        conFclBookingId: "",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conffBookingTranshipmentId: "",
        assignmentNumber: "",
        bookingNumber: "",
        validityBookingDate: "",
        ffExportFclConsoSeries: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        // ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "no",
        stuffingType: "",
        vesselEta: null,
        vesselEtd: null,
        vgmCutOffDate: "",
        documentCutOffDate: "",
        vessel_sale_start_date: "",
        handover_cutoff_date: "",
        voyageNo: "",
        is_mainbookingFlow: "",
      },
      
      Created: "",
      Updated: "",
      portMasterList: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      TranshipmentDetail: {
        ffBookingTranshipmentId: "",
        conFclBookingId: "",
        conffBookingTranshipmentId: "",
        tentativePortId: "",
        tentativePortName: "",
        etaDate: "",
        etaTime: "",
        etdDate: "",
        etdTime: "",
      },
      tentativeDetailArray: [],
      errorList: {
        tentativePortId: "",
        etaDate: "",

        etdDate: "",
      },
      deleteId: "",
      validateTrans: true,
      arrayError: [
        "Select  Transhipment port Name",
        "Select ETA Date",

        "Select ETA Date",
      ],
      errorBooking: {
        bookingNumber: "",
        validityBookingDate: "",
        bookingDate: "",
        SICutOff: "",
        vessel_sale_start_date: "",
        handover_cutoff_date: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
      },
      bookingLengthError: "",
      arrayBookingError: [
        "Enter Booking Number",
        "Enter Validity Booking Number",
        "Enter Booking Release Date",
        "Enter SI Cut off",
        "Enter Vessel Sail Date",
        "Enter Handover Cut off",
        "Enter VGM Cut off",
        "Enter TR Cut off",
      ],
      editIndex: "",
    };
  },

  mounted() {},
  watch: {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
  },
  computed: {
    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    portList() {
      return this.portMasterList;
    },

    // bookingShipmentList() {
    //   return this.bookingShipmentName;
    // },
  },
  methods: {
    ChangeDate(vessel_sale_start_date,sicutoff) {

      if(vessel_sale_start_date!=undefined || vessel_sale_start_date!=null || vessel_sale_start_date!=''){

        const now = new Date(vessel_sale_start_date);
        const handover_cutoff_date = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 10);
        const vgmCutOffDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 8);
        const documentCutOffDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 8);

        if(sicutoff == ''){

          const SICutOff  = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 8);
          this.BookingShippingLine.SICutOff = SICutOff;
        }

        this.BookingShippingLine.handover_cutoff_date = handover_cutoff_date;
        this.BookingShippingLine.vgmCutOffDate = vgmCutOffDate;
        this.BookingShippingLine.documentCutOffDate = documentCutOffDate;
      }
    },
    SelectConsoleBooking(items) {
      let validity_end = "";
      let booking_id = "";
      let bookingDate = "";
      let sicutoff = "";
      let vesselEta = "";
      let vesselEtd = "";
      let voyageNo = "";
      let vesselName = "";
      let vessel_sale_start_date = "";

      for (let i = 0; i < this.ConsoleBookingList.length; i++) {
        const item = this.ConsoleBookingList[i];
        if (items == item.booking_no) {
          booking_id = item.booking_id;
          bookingDate = item.validity_start;
          validity_end = item.validity_end;
          sicutoff = item.sicutoff;
          vesselEta = item.vesselEta;
          vesselEtd = item.vesselEtd;
          voyageNo = item.voyageNo;
          vessel_sale_start_date = item.vessel_sale_start_date;
          vesselName = item.vesselName;
        }
      }
      this.BookingShippingLine.console_booking_id = booking_id;
      this.BookingShippingLine.bookingDate = bookingDate;
      this.BookingShippingLine.validityBookingDate = validity_end;
      // this.BookingShippingLine.SICutOff = sicutoff; 

      this.BookingShippingLine.SICutOff = sicutoff == "1970-01-01" || sicutoff == undefined || sicutoff == null?'':sicutoff;
      this.BookingShippingLine.vesselEta = vesselEta == "1970-01-01" || vesselEta == undefined || vesselEta == null?'':vesselEta;
      this.BookingShippingLine.vesselEtd = vesselEtd == "1970-01-01" || vesselEtd == undefined || vesselEtd == null?'':vesselEtd;

      this.BookingShippingLine.voyageNo = voyageNo;
      this.BookingShippingLine.vessel_sale_start_date = vessel_sale_start_date;
      this.BookingShippingLine.vesselName = vesselName;

      this.ChangeDate(this.BookingShippingLine.vessel_sale_start_date, this.BookingShippingLine.SICutOff);

    },
    getLocationList_bak(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    proceedToExec() {
      this.$router.push({
        path: "/ffExportCon/executionWHStuffingIcdCon",
      });
    },
    routePage() {
      this.$router.push({
        path: "/ffExportCon/executionWHStuffingIcdCon",
      });
    },
    // autoENSDate() {
    //   this.BookingShippingLine.SICutOff = this.BookingShippingLine.ENSCutDate;
    // },
    onClose() {
      if (this.BookingShippingLine.stuffingType == "factoryStuffing") {
        this.$router.push({
          path: "/freightForward/ffExecution",
        });
      } else {
        this.$router.push({
          path: "/freightForward/ffexecutionWareHouse",
        });
      }
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "con_fcl_booking_transhipment",
          tableId: "conffBookingTranshipmentId",
          isActive: "isDepartmentActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            this.getData();
            this.deleteId = "";
          })
          .catch((error) => {});
      }
    },
    viewEdit(id, index) {
      if (id == "") {
        this.editIndex = index;
        Object.keys(this.TranshipmentDetail).map((x) => {
          this.TranshipmentDetail[x] = this.tentativeDetailArray[index][x];
        });
      } else {
        let array = this.tentativeDetailArray.filter((x) => {
          return x.conffBookingTranshipmentId == id;
        });

        Object.keys(this.TranshipmentDetail).map((x) => {
          this.TranshipmentDetail[x] = array[0][x];
        });
      }
    },
    DeleteList(id, index) {
      if (id == "") {
        this.tentativeDetailArray.splice(index, 1);
      } else {
        this.deleteId = id;
        this.alert.content = "Are you sure you want to delete this data?";
        this.$refs["addPop6"].open();
      }
    },
    previousSalesView() {
      // window.history.go(-1);
      this.$router.push({
        path: "/ffExportCon/ffExportFclConsolidation",
      });
    },
    validateTranshipment() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.TranshipmentDetail[x] == "") {
          this.errorList[x] = this.arrayError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    addBookingDetail() {
      this.BookingShippingLine["transhipmentDetail"] =
        this.tentativeDetailArray;

      this.validateBooking();

      if (this.validateTrans != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConsoBookingOrderTracking.php`,
          data: JSON.stringify(this.BookingShippingLine),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set(
                "editconFclBookingId",
                data.conFclBookingId
              );
              this.BookingShippingLine.conFclBookingId = data.conFclBookingId;
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";

                if (data.subscriptionId) {
                  this.alert.content =
                    "Data Added Successfully & Subscription created";
                  this.trackingId = data.subscriptionId;
                } else {
                  this.alert.content =
                    "Data Added Successfully & " + data.trackingMsg;
                }
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.$sessionsStorage.set(
                "editffConExecutionId",
                data.ffConExecutionId
              );
              this.$refs["addPopBooking"].open();
            }
          })
          .catch((error) => {});
      }
    },

    validateBooking() {
      let validate_new = true;
      Object.keys(this.errorBooking).map((x, index) => {
        if (this.BookingShippingLine[x] == "") {
          this.errorBooking[x] = this.arrayBookingError[index];
          validate_new = false;
        }
      });

      if (
        this.BookingShippingLine.bookingShipment == "yes" &&
        this.tentativeDetailArray.length == 0
      ) {
        this.bookingLengthError = "Select Atleast one transhipment";
        validate_new = false;
      } else {
        this.bookingLengthError = "";
      }

      if (!this.BookingShippingLine.bookingDate) {
        this.errorBooking.bookingDate = "Enter Booking Release Date";
        validate_new = false;
      }

      if (!this.BookingShippingLine.SICutOff) {
        this.errorBooking.SICutOff = "Enter SI Cut off";
        validate_new = false;
      }

      if (!this.BookingShippingLine.vessel_sale_start_date) {
        this.errorBooking.vessel_sale_start_date = "Enter Vessel Sail Date";
        validate_new = false;
      }

      if (!this.BookingShippingLine.handover_cutoff_date) {
        this.errorBooking.handover_cutoff_date = "Enter Handover Cut off";
        validate_new = false;
      }

      if (!this.BookingShippingLine.vgmCutOffDate) {
        this.errorBooking.vgmCutOffDate = "Enter VGM Cut off";
        validate_new = false;
      } 
      
      if (!this.BookingShippingLine.documentCutOffDate) {
        this.errorBooking.documentCutOffDate = "Enter TR Cut off";
        validate_new = false;
      }

      
      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    addTentativeDetail() {
      let array_new = this.portMasterList;

      var obj = {};
      this.validateTranshipment();

      if (
        this.$sessionsStorage.get("editconFclBookingId") == "" ||
        this.$sessionsStorage.get("editconFclBookingId") == undefined ||
        this.$sessionsStorage.get("editconFclBookingId") == null
      ) {
        if (this.validateTrans != false) {
          let arrayPort = array_new.filter((x) => {
            return x.pickupId == this.TranshipmentDetail.tentativePortId;
          })[0];
          this.TranshipmentDetail.tentativePortName = arrayPort.pickupLocation;
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
          var obj1 = {};
          Object.keys(this.TranshipmentDetail).map((x) => {
            obj1[x] = this.TranshipmentDetail[x];
            this.TranshipmentDetail[x] = "";
          });
          Object.keys(this.errorList).map((x) => {
            this.errorList[x] = "";
          });

          if (
            this.editIndex == "" &&
            (this.editIndex != "0" || this.editIndex != 0)
          ) {
            this.tentativeDetailArray.push(obj1);
          } else {
            this.tentativeDetailArray.splice(this.editIndex, 1);
            this.tentativeDetailArray.splice(this.editIndex, 0, obj1);
            this.editIndex = "";
          }
          setTimeout(function () {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
          }, 1000);
        }
      } else {
        this.TranshipmentDetail["conFclBookingId"] = this.$sessionsStorage.get(
          "editconFclBookingId"
        );
        if (this.validateTrans != false) {
          let arrayPort = array_new.filter((x) => {
            return x.pickupId == this.TranshipmentDetail.tentativePortId;
          })[0];
          this.TranshipmentDetail.tentativePortName = arrayPort.pickupLocation;
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/addConBookingTranshipment.php`,
            data: JSON.stringify(this.TranshipmentDetail),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                if (data.msg == "Inserted Successfully") {
                  Object.keys(this.TranshipmentDetail).map((x) => {
                    obj[x] = this.TranshipmentDetail[x];
                    this.TranshipmentDetail[x] = "";
                  });
                  Object.keys(this.errorList).map((x) => {
                    this.errorList[x] = "";
                  });
                  obj["conffBookingTranshipmentId"] =
                    data.conffBookingTranshipmentId;

                  this.tentativeDetailArray.push(obj);
                } else {
                  Object.keys(this.TranshipmentDetail).map((x) => {
                    this.TranshipmentDetail[x] = "";
                  });
                  Object.keys(this.errorList).map((x) => {
                    this.errorList[x] = "";
                  });
                }

                setTimeout(function () {
                  $("#addButtonLoader").css("display", "block");
                  $("#loader").css("display", "none");
                }, 1000);

                this.getData();
              }
            })
            .catch((error) => {});
        }
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#ffBookingTentative").DataTable();
      });
    },
    async getData() {
      this.doLoading();
      if (this.tentativeDetailArray.length == 1) {
        this.tentativeDetailArray = [];
      }

      let new_data = {
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId:
          this.$sessionsStorage.get("editconFclBookingId") != "" &&
          this.$sessionsStorage.get("editconFclBookingId") != undefined
            ? this.$sessionsStorage.get("editconFclBookingId")
            : "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToFCLCONSOBooking.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }
            if (data.ConsoleBookingList.length > 0) {
              this.ConsoleBookingList = data.ConsoleBookingList;
            } else {
              this.ConsoleBookingList = [];
            }
            console.log("Priyanshu Singh=>", data);
            this.portMasterList = data.portLocationArray;

            this.Created = data.Created;
            this.Updated = data.Updated;
            if (data.ffBookingDetail.length > 0) {
              Object.keys(this.BookingShippingLine).map((x) => {
                // if(data.ffBookingDetail[0][x].includes("1970")){
                //   this.BookingShippingLine[x] = "";
                // }
                // else{
                //    this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
                // }

                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });

              this.$sessionsStorage.set(
                "editconFclBookingId",
                data.ffBookingDetail[0]["conFclBookingId"]
              );
            } else {
              this.BookingShippingLine.assignmentNumber =
                data.editFFEX[0].ffExportFclConsoSeries;
              this.BookingShippingLine.conFclBookingId = "";
            }

            this.BookingShippingLine.allModuleId = data.editFFEX[0].allModuleId;
            this.BookingShippingLine.stuffingType =
              data.editFFEX[0].stuffingType;
            this.BookingShippingLine.is_mainbookingFlow =
              data.editFFEX[0].is_mainbookingFlow;
              this.BookingShippingLine.is_booking_updated =
              data.editFFEX[0].is_booking_updated;
            this.doLoadingClose();
            // this.JqueryFun();

            // this.getTrackingDetails();
                        this.getTrackingDetails();
            this.getSubscription();

            console.log(this.BookingShippingLine.bookingNumber);

            if(this.BookingShippingLine.bookingNumber){
               this.SelectConsoleBooking(this.BookingShippingLine.bookingNumber);
            }
          }
        })
        .catch((error) => {});
    },
    getSubscription() {
      if (this.trackingId != "") {
        let payload = {
          subscriptionId: this.trackingId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Tracking/globalTracking.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            this.isLoading = false;
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              console.log("Result => ", JSON.parse(data.data));
              data.data = JSON.parse(data.data);
              if (data.data.containershipments.length > 0) {
                this.BookingShippingLine.vesselName = data.data.containershipments[0]["leg1_vessel"]? data.data.containershipments[0]["leg1_vessel"]["name"]: this.BookingShippingLine.vesselName;
                  this.BookingShippingLine.voyageNo = data.data.containershipments[0]["leg1_voyage"] ? data.data.containershipments[0]["leg1_voyage"]
                  : this.BookingShippingLine.voyageNo;
                this.BookingShippingLine.vesselEta = data.data.containershipments[0]["pol_arrival_planned_initial"]? data.data.containershipments[0]["pol_arrival_planned_initial"] : this.BookingShippingLine.vesselEta;
                this.BookingShippingLine.vesselEtd = data.data.containershipments[0]["pol_vsldeparture_planned_initial"] ? data.data.containershipments[0]["pol_vsldeparture_planned_initial"]:this.BookingShippingLine.vesselEtd;
              }
            }
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("Err => ", error);
          });
      }
    },

    getTrackingDetails() {
      let new_data = {
        allModuleId: this.ALLMODULE,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
            this.getSubscription();
          }
        })
        .catch((error) => {});
    },
    // getTrackingDetails() {
    //   let new_data = {
    //     allModuleId: this.BookingShippingLine.allModuleId,
    //   };

    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
    //     data: JSON.stringify(new_data),
    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };

    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;

    //       if (status == 200 && data) {
    //         if (data.BIdType && data.BIdType.length > 0) {
    //           this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
    //           this.trackingId = data.BIdType[0].id;
    //         } else {
    //           this.trackingId = "";
    //         }
    //       }
    //     })
    //     .catch((error) => {});
    // },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// fclConsoBookingOrder.vue?4dbf51d8